import { _axios } from '../plugins/axios'
import { globals } from '../main.js'
import Configuration from '@/configuration'

const Vue = {}
Vue.axios = _axios

function makeRequest(callback) {
  return globals.$authService
    .getAccessToken()
    .then((response) => {
      callback(response)
    })
    .catch(function (error) {
      //Acquire token silent failure, send an interactive request.
      new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

const SLICE_SIZE = 6291456 // 6 MB

const uploadPart = ({ file, mocId, trackProgress }) => {
  return new Promise((resolve, reject) => {
    let nextSlice = SLICE_SIZE
    let blob = file.slice(0, nextSlice)
    let count = 1
    let sizeDone = 0

    upload({ file, mocId, trackProgress })

    function upload({ file, mocId, trackProgress }) {
      const data = new FormData()
      data.append(`piece`, blob)
      data.append(`comment`, file.comments || '')
      data.append(`mocId`, mocId)
      data.append(`mimeType`, file.type)
      data.append(`fileName`, file.name)

      const axiosRequest = (accessToken) => {
        Vue.axios
          .post(Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/uploadmultipart/${mocId}`), data, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'X-Part-Number': count,
              'X-File-Size': file.size,
              'X-Slice-Size': SLICE_SIZE
            }
          })
          .then(() => {
            sizeDone += SLICE_SIZE
            const percentDone = Math.floor((sizeDone / file.size) * 100)
            trackProgress({ percentDone })

            if (nextSlice < file.size) {
              nextSlice += SLICE_SIZE
              blob = file.slice(sizeDone, nextSlice)
              count++
              upload({ file, mocId, trackProgress })
            } else {
              resolve({ complete: true })
            }
          })
          .catch((e) => {
            const error = new Error(e)
            error.metadata = {
              count
            }
            reject(error)
          })
      }
      makeRequest(axiosRequest)
    }
  })
}

export default {
  async upload({ file, mocId }, trackProgress) {
    return uploadPart({
      file,
      mocId,
      trackProgress
    })
  },
  async getPreSignedUrl(mocId, filename, cancelToken) {
    return new Promise((resolve, reject) => {
      const axiosRequest = (accessToken) => {
        Vue.axios
          .put(
            Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/GeneratePreSignedURLPut/`),
            {},
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              },
              params: {
                mocId,
                filename
              },
              cancelToken: cancelToken
            }
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((e) => reject(e))
      }
      makeRequest(axiosRequest)
    })
  },
  async getPreSignedUrlForDownload(mocId, filename, versionId, cancelToken) {
    return new Promise((resolve, reject) => {
      const axiosRequest = (accessToken) => {
        Vue.axios
          .get(Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/GeneratePreSignedURLGet/`), {
            headers: {
              Authorization: `Bearer ${accessToken}`
            },
            params: {
              mocId,
              filename,
              versionId
            },
            cancelToken: cancelToken
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((e) => reject(e))
      }
      makeRequest(axiosRequest)
    })
  },
  async downloadBulk(mocId, fileNames) {
    return new Promise((resolve, reject) => {
      const axiosRequest = (accessToken) => {
        Vue.axios
          .post(
            Configuration.value('docsEndPoint').concat(`/api/SupportingDocuments/BulkDownload/${mocId}`),
            { fileNames },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              },
              responseType: 'blob'
            }
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch((e) => reject(e))
      }
      makeRequest(axiosRequest)
    })
  },
  async uploadToPreSignedUrl(url, file, trackProgress, cancelToken) {
    return Vue.axios.put(url, file, {
      onUploadProgress(e) {
        const percentDone = Math.round((e.loaded * 100) / e.total)
        trackProgress({ percentDone })
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      cancelToken: cancelToken
    })
  }
}
